import { Skeleton } from 'primereact/skeleton';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { useGetCertificateDetailsById } from '../../../../../../hooks/api/certificates';
import { CertificateStatus } from '../../../../../../shared/interfaces/ICertificate';
import CertificateDetailsTabView from '../../../../../certificate-details/components/certificate-details-tab-view/CertificateDetailsTabView';
import GoBackToMyCertificatesButton from '../../../../../certificate-details/components/go-back-to-my-certificates-button/GoBackToMyCertificatesButton';
import ShareCertificateButton from '../../../../../certificate-details/components/share-certificate-button/ShareCertificateButton';
import MyCertificatesTable from './components/my-certificates-table/MyCertificatesTable';

const MyCertificatesTab = (): JSX.Element => {
  const { certificateId } = useParams() as { certificateId?: string };
  const { t } = useTranslation();

  const {
    data: certificate,
    isLoading,
    isError,
  } = useGetCertificateDetailsById(
    { certificateId: certificateId ?? '' },
    {
      enabled: !!certificateId,
      retry: 0,
    },
  );

  if (!certificateId) {
    return (
      <div className='flex flex-column'>
        <MyCertificatesTable />
      </div>
    );
  }

  if (isError || (!isLoading && !certificate)) {
    return <Navigate to='/404' replace={true} />;
  }

  return (
    <div className='flex flex-column gap-2 mt-2'>
      <GoBackToMyCertificatesButton />

      {isLoading ? (
        <Skeleton height='40px' width='28%' />
      ) : (
        <div className='flex flex-column md:flex-row w-full align-items-center justify-content-between gap-2 md:gap-5'>
          <h1 className='text-3xl pt-2 pb-2 m-0 w-full'>{certificate?.type}</h1>
          <ShareCertificateButton
            certificateType={certificate?.type || ''}
            certificateId={String(certificate?.id || '')}
            disabled={certificate?.status === CertificateStatus.EXPIRED}
            tooltip={
              certificate?.status === CertificateStatus.EXPIRED
                ? t('certificateDetailsPage.buttons.shareCertificateDisabledTooltipText')
                : undefined
            }
            tooltipOptions={{ showOnDisabled: true, position: 'top' }}
          />
        </div>
      )}

      {isLoading ? (
        <Skeleton height='45px' width='30%' className='mt-4' />
      ) : (
        <CertificateDetailsTabView />
      )}
    </div>
  );
};

export default MyCertificatesTab;
